module.exports = __webpack_public_path__ + "img/404image.878f1efc.png";